var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.taskLoader)?_c('v-progress-linear',{attrs:{"color":"accent","indeterminate":""}}):_vm._e(),(_vm.task && _vm.task.id)?_c('task-card',{key:_vm.task.id + 'task-card',attrs:{"task-id":_vm.task.id,"task-view":"claimed","task-action":true,"selected-task-id":_vm.task.id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }